const rowsPerPage = 10

const optionsMenu = [{
    label: "View",
    visibility: "ALL"
}]

const columns = [
    { id: 'segmentId', label: 'Segment ID', minWidth: 200 },
    { id: 'name', label: 'Segment Name', minWidth: 200 },
    {
        id: 'createdBy',
        label: 'Created By',
        minWidth: 200,
    },
    {
        id: 'status',
        label: 'Segment Status',
        minWidth: 200,
        // align: 'right',
    },
    {
        id: 'options',
        label: '',
    },
];

const defaultState = {
    page: 0,
    searchBySegmentName: "",
    searchBySegmentId: "",
    disableApply: false,
    selectedIndex: -1
}

export default {
    rowsPerPage,
    columns,
    defaultState,
    optionsMenu
}
